import React from "react";
import { ReactComponent as BackButton } from "../../images/back-button.svg";
import { ReactComponent as MakersLeagueImage } from "../../images/makers-league-image.svg";
import { ReactComponent as UICoachLogo } from "../../images/icons/uicoach-logo.svg";
import { ReactComponent as MakerLeagueLogo } from "../../images/makersleague-logo.svg";
import { ReactComponent as NerofitLogo } from "../../images/nerofit-logo.svg";
import { ReactComponent as CopyPageLogo } from "../../images/copypage-logo.svg";
import { ReactComponent as InvisageLogo } from "../../images/icons/invisage-logo.svg";
import { ReactComponent as LinkIcon } from "../../images/icons/link-icon.svg";
import nerofitImage from "../../images/nerofit-apparel-hero.png";
import uicoachHero from "../../images/uicoach-hero.png";
import invisageHero from "../../images/invisage-hero.png";

function DialogShell({ id, openDialog, children }) {
  if (openDialog !== id) {
    return null;
  }

  return (
    <div className="absolute z-40 w-full h-full grid overflow-y-scroll">
      {children}
    </div>
  );
}

function DialogBody({ onClose, children, right }) {
  return (
    <div className="bg-pal-bg text-white w-full h-full grid lg:flex lg:flex-row">
      <div className="w-full grid items-start lg:grid h-full p-10">
        <BackButton
          onClick={onClose}
          className="w-12 h-12 lg:w-16 lg:h-16 cursor-pointer"
        />
        <div className="h-full w-full pt-20">{children}</div>
      </div>
      {right}
    </div>
  );
}

export default function ProjectDialogs({ openDialog, onCloseDialog }) {
  return (
    <>
      <DialogShell id="copyPage" openDialog={openDialog}>
        <div className="bg-pal-bg text-white lg:max-h-screen lg:overflow-hidden w-full h-full grid lg:flex lg:flex-row">
          <div className="w-full grid  items-start   h-full p-8 lg:p-10">
            <BackButton
              onClick={() => onCloseDialog("copyPage")}
              className=" w-12 h-12 lg:w-16 lg:h-16 cursor-pointer"
            />
            <div className="h-full w-full pt-20">
              <CopyPageLogo className="w-32 h-32 mb-10" />
              <h3 className=" text-xl mb-2 text-pal-green">Copy Page</h3>
              <p>
                Copy Page is an AI-powered copywriter for that enables you to
                create great content without the need for a professional
                copywriter.
              </p>
              <span className="button-shell mt-10">
                <a
                  className="button w-min row-center"
                  href="https://copypage.io/"
                  target="__blank"
                >
                  <span className=" whitespace-nowrap">Check it out</span>{" "}
                  <LinkIcon className="w-5 h-5 ml-2" />
                </a>
              </span>
            </div>
          </div>
          <div className="flex h-full w-full flex-col items-center justify-center bg-black">
            <CopyPageLogo className="h-1/4 w-1/4 max-w-[min(280px,40vw)]" />
          </div>
        </div>
      </DialogShell>

      <DialogShell id="uicoach" openDialog={openDialog}>
        <DialogBody
          onClose={() => onCloseDialog("uicoach")}
          right={
            <div className="flex h-full min-h-[min(50vh,280px)] w-full items-center justify-center overflow-hidden bg-white p-4 lg:min-h-0 lg:p-6">
              <img
                src={uicoachHero}
                alt="UI Coach landing page"
                className="h-auto max-h-full w-full max-w-full object-contain object-center"
              />
            </div>
          }
        >
          <UICoachLogo className="w-32 h-32 mb-10" />
          <h3 className=" text-xl mb-2 text-pal-green">UI Coach</h3>
          <p>
            UI Coach helps you become a better UI designer by generating UI
            design challenges which include: Project ideas, Color palettes,
            Illustrations libraries
          </p>
          <span className="button-shell mt-10">
            <a className="button w-min row-center" href="https://uicoach.io/" target="__blank">
              <span className=" whitespace-nowrap">Check it out</span>{" "}
              <LinkIcon className="w-5 h-5 ml-2" />
            </a>
          </span>
        </DialogBody>
      </DialogShell>

      <DialogShell id="invisage" openDialog={openDialog}>
        <DialogBody
          onClose={() => onCloseDialog("invisage")}
          right={
            <div className="flex h-full min-h-[min(50vh,280px)] w-full items-center justify-center overflow-hidden bg-white p-4 lg:min-h-0 lg:p-6">
              <img
                src={invisageHero}
                alt="Invisage landing page"
                className="h-auto max-h-full w-full max-w-full object-contain object-center"
              />
            </div>
          }
        >
          <InvisageLogo className="mb-10 h-32 w-32" />
          <h3 className="text-xl mb-2 text-pal-green">Invisage</h3>
          <p>
            AI-powered analytics app that turns data into collaborative
            dashboards: auto-generated charts, key metrics, and insights
            you can explore and refine—turning messy uploads into a
            shareable dashboard.
          </p>
          <span className="button-shell mt-10">
            <a
              className="button w-min row-center"
              href="https://invisage.io/"
              target="__blank"
            >
              <span className="whitespace-nowrap">Check it out</span>{" "}
              <LinkIcon className="ml-2 h-5 w-5" />
            </a>
          </span>
        </DialogBody>
      </DialogShell>

      <DialogShell id="makersLeague" openDialog={openDialog}>
        <DialogBody
          onClose={() => onCloseDialog("makersLeague")}
          right={
            <div className=" h-full w-auto max-h-screen bg-black">
              <MakersLeagueImage className="h-full  w-auto max-h-screen max-w-screen" />
            </div>
          }
        >
          <MakerLeagueLogo className="w-32 h-32 mb-10" />
          <h3 className=" text-xl mb-2 text-pal-green">Makers League</h3>
          <p>
            Makers league is a a platform that connects developers, designers,
            marketers or anyone who's interested in building
            tech startups and digital products.
          </p>
          <span className="button-shell mt-10">
            <a
              className="button w-min row-center"
              href="https://makersleague.co/"
              target="__blank"
            >
              <span className=" whitespace-nowrap">Check it out</span>{" "}
              <LinkIcon className="w-5 h-5 ml-2" />
            </a>
          </span>
        </DialogBody>
      </DialogShell>

      <DialogShell id="nerofit" openDialog={openDialog}>
        <DialogBody
          onClose={() => onCloseDialog("nerofit")}
          right={
            <div className="w-full h-full flex justify-end flex-col items-end bg-black">
              <img
                src={nerofitImage}
                className="h-full w-full max-w-screen object-cover object-center"
                alt="Nero-Fit Apparel"
              />
            </div>
          }
        >
          <NerofitLogo className="w-32 h-32 mb-10" />
          <h3 className=" text-xl mb-2 text-pal-green">Nero-Fit Apparel</h3>
          <p className="mb-10">
            Nero-fit apparel is a fitness clothing brand that focuses on
            building a healthy, strong community of people that radiate
            confidence.
          </p>
          <span className="button-shell">
            <a
              className="button w-min row-center"
              href="https://www.instagram.com/nerofitapparel/?hl=en"
              target="__blank"
            >
              <span className=" whitespace-nowrap">Check it out</span>{" "}
              <LinkIcon className="w-5 h-5 ml-2" />
            </a>
          </span>
        </DialogBody>
      </DialogShell>
    </>
  );
}
